import React from "react";
import { Col, Row } from "react-bootstrap";

const AboutChild_Languages = (props) => {
  let Int_Array = ["Gujarati", "English", "Hindi"];
  return (
    <>
      <h2 className="m-0 pb-3">My Languages</h2>
      <hr />
      {Int_Array?.map((item, index) => (
        <>
          <Row className="py-2">
            <Col md={12}>
              <h6 className="m-0 title-primary">{item}</h6>
            </Col>
          </Row>
          <hr />
        </>
      ))}
    </>
  );
};

export default AboutChild_Languages;
